import Cookies from "js-cookie"

export const setCoookie = (name: string, value: string) => {
  Cookies.set(name, value)
}

export const ifHasNameAndValueSetCoookie = (name?: string, value?: string) => {
  if (!name || !value) {
    return
  }

  setCoookie(name, value)
}
